export default "__VITE_ASSET__DA29_WJJ__"